//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "PittsburghBrainStemScore",
  data() {
    return {
      form: {
        f1: "",
        f2: "",
        f3: "",
        f4: "",
        f5: "",
        f6: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "1", name: "两侧消失" },
        {
          value: "2",
          name: "两侧都有",
        },
      ],
      dataList2: [
        { value: "1", name: "两侧消失" },
        {
          value: "2",
          name: "两侧都有",
        },
      ],
      dataList3: [
        { value: "1", name: "两侧消失" },
        {
          value: "2",
          name: "两侧都有",
        },
      ],
      dataList4: [
        { value: "1", name: "缺乏" },
        {
          value: "2",
          name: "存在",
        },
      ],
      dataList5: [
        { value: "1", name: "缺乏" },
        {
          value: "2",
          name: "存在",
        },
      ],
      dataList6: [
        { value: "1", name: "缺乏" },
        {
          value: "2",
          name: "存在",
        },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      console.log(result);
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/PittsburghBrainStemScore.vue